import { render, staticRenderFns } from "./CalendarDutyCard.vue?vue&type=template&id=b081d960&scoped=true&"
import script from "./CalendarDutyCard.vue?vue&type=script&lang=js&"
export * from "./CalendarDutyCard.vue?vue&type=script&lang=js&"
import style0 from "./CalendarDutyCard.vue?vue&type=style&index=0&id=b081d960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b081d960",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
